var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.type!=='loading')?_c('i',{class:`ipub-icon iconfont ${this.type}`,on:{"click":_vm.handleClick}}):_c('i',{class:`ipub-loading ipub-icon iconfont iconLoading`})
}
var staticRenderFns = []

export { render, staticRenderFns }